import { Box } from '@mui/material'
import { RpcError } from '@protobuf-ts/runtime-rpc'
import { TaskV1TaskActionsServiceMarkProvisionComplete } from 'c1gen/permissions'
import { C1LoadingButton } from 'components/core/button/index'
import { TaskPrimaryActionsV2Variant } from 'components/core/task-list-v2/task-list-v2-components/TaskPrimaryActionsV2'
import { HasCapability } from 'components/no-ui/capability'
import { canActOn } from 'components/pages/task/state'
import { useAlert } from 'hooks/useAlert/index'
import { TaskValue } from 'lib/actions/task'
import { TaskActionType } from 'pbts/c1/api/task/v1/task'
import { FC, useCallback } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useTicketActionTracker } from 'redux_toolkit/lib/TicketActionTracker'

export const MarkProvisionCompletePrimaryAction: FC<{ task: TaskValue, variant: TaskPrimaryActionsV2Variant }> = ({ task, variant }) => {
    const intl = useIntl()
    const toast = useAlert()
    const ticketActionTracker = useTicketActionTracker()

    const handleClick = useCallback(async (): Promise<void> => {
        try {
            await ticketActionTracker?.markProvisionComplete(task)
        } catch (err) {
            toast(
                intl.formatMessage(
                    {
                        id: 'task_mark_provision_complete_error',
                        defaultMessage: 'Error marking provision complete on task. {code}: {msg}',
                    },
                    {
                        code: (err as RpcError).code,
                        msg: (err as RpcError).message,
                    },
                ),
                'error',
            )
        }
    }, [intl, task, ticketActionTracker, toast])

    if (!canActOn(task, TaskActionType.PROVISION_COMPLETE)) {
        return null
    }

    return (
        <Box>
            <HasCapability permission={TaskV1TaskActionsServiceMarkProvisionComplete}>
                <C1LoadingButton
                    variant={variant === 'contained' ? 'contained' : 'outlined'}
                    key={`components_task_list_approve_option_${task.id}`}
                    onClick={handleClick}
                    loading={!ticketActionTracker}
                >
                    {task.type && task.type.taskType.oneofKind === 'grant' ? (
                        <FormattedMessage
                            id="component_task_list_mark_provisioned_option_label"
                            defaultMessage="Provisioned"
                        />
                    ) : (
                        <FormattedMessage
                            id="component_task_list_mark_deprovisioned_option_label"
                            defaultMessage="Deprovisioned"
                        />
                    )}
                </C1LoadingButton>
            </HasCapability>
        </Box>
    )
}
